export enum TYPE_FIELD {
  TEXT = 'text',
  LONG_TEXT = 'long_text',
  DATE = 'date',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  LAST_MODIFIED = 'last_modified',
  LAST_MODIFIED_BY = 'last_modified_by',
  CREATED_BY = 'created_by',
  DURATION = 'duration',
  URL = 'url',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
  COUNT = 'count',
  UUID = 'uuid',
  PASSWORD = 'password',
}

export const listType = [
  {
    value: TYPE_FIELD.TEXT,
    label: 'Single line text',
  },
  {
    value: TYPE_FIELD.LONG_TEXT,
    label: 'Long text',
  },
  {
    value: TYPE_FIELD.DATE,
    label: 'Date',
  },
  {
    value: TYPE_FIELD.NUMBER,
    label: 'Number',
  },
  {
    value: TYPE_FIELD.BOOLEAN,
    label: 'Boolean',
  },
  // {
  //   value: TYPE_FIELD.LAST_MODIFIED,
  //   label: 'Last modified',
  // },
  // {
  //   value: TYPE_FIELD.LAST_MODIFIED_BY,
  //   label: 'Last modified by',
  // },
  // {
  //   value: TYPE_FIELD.CREATED_BY,
  //   label: 'Created by',
  // },
  // {
  //   value: TYPE_FIELD.DURATION,
  //   label: 'Duration',
  // },
  // {
  //   value: TYPE_FIELD.URL,
  //   label: 'Url',
  // },
  // {
  //   value: TYPE_FIELD.EMAIL,
  //   label: 'Email',
  // },
  // {
  //   value: TYPE_FIELD.PHONE_NUMBER,
  //   label: 'Phone number',
  // },
  // {
  //   value: TYPE_FIELD.COUNT,
  //   label: 'Count',
  // },
  // {
  //   value: TYPE_FIELD.UUID,
  //   label: 'Uuid',
  // },
  // {
  //   value: TYPE_FIELD.PASSWORD,
  //   label: 'Password',
  // },
];
